// removed by extract-text-webpack-plugin
module.exports = {"desktopMediaBreakpoint":"1064px","tabletMediaBreakpoint":"900px","mobileMediaBreakpoint":"480px"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/_variables.scss
// module id = gzpo
// module chunks = 1